import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import api, { ApiError } from '../lib/apiClient';
import { usePublicBranding } from '../hooks/usePublicBranding';
import vnpfLogo from '../assets/vnpf-logo.png';
import './Login.css';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const branding = usePublicBranding();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <img src={branding.app_icon_url ?? vnpfLogo} alt="" className="brand-mark-lg" />
        <h1>{branding.app_name}</h1>
        <p className="muted">Reset your password</p>

        {sent ? (
          <>
            <div className="alert alert-success">
              If that email is registered, a password reset link has been sent. Check your inbox.
            </div>
            <Link to="/login" className="btn btn-ghost login-secondary-link">
              Back to sign in
            </Link>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <div className="alert alert-error">{error}</div>}
            <label>
              Email
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
            </label>
            <button className="btn btn-primary" disabled={loading}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
            <Link to="/login" className="login-secondary-link">
              Back to sign in
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
